export const YT_FILTER_DATA = [
  { title: "Music", id: "ox1" },
  { title: "Sports", id: "ox2" },
  { title: "Gaming", id: "ox3" },
  { title: "Entertainment", id: "ox4" },
  { title: "Comedy", id: "ox5" },
  { title: "News", id: "ox6" },
  { title: "Anime", id: "ox7" },
  { title: "Classic", id: "ox8" },
  { title: "Documentary", id: "ox9" },
  { title: "Thriller", id: "ox10" },
  { title: "Science", id: "ox11" },
  { title: "Horror", id: "ox12" },
  { title: "Sci-Fi", id: "ox13" },
  { title: "Vlogging", id: "ox14" },
  { title: "Fantasy", id: "ox15" },
  { title: "Adventure", id: "ox16" },
  { title: "Movies", id: "ox17" },
  { title: "Action", id: "ox18" },
  { title: "Education", id: "ox19" },
]
